import { Badge } from "@/components/ui/badge";
import { Image as ImageIcon } from "lucide-react";

function Gallery() {
  const galleryPhotos = [
    { src: "/images/gallery/IMG_1354.jpg", caption: "STEAM Program Award Ceremony" },
    { src: "/images/gallery/DSC03803_VSCO.jpeg", caption: "THOROpy Program Activities" },
    { src: "/images/gallery/IMG_1359.jpg", caption: "Youth Engagement" },
    { src: "/images/gallery/IMG_1377.jpg", caption: "Community Programs" },
    { src: "/images/gallery/IMG_1373.jpg", caption: "Bridge Program Training" },
    { src: "/images/gallery/IMG_1387.jpg", caption: "Leadership Development" },
    { src: "/images/gallery/IMG_1458.jpg", caption: "STEAM Workshop" },
    { src: "/images/gallery/IMG-8210.JPG", caption: "Community Events" },
    { src: "/images/gallery/IMG_1380.jpg", caption: "Youth Activities" },
    { src: "/images/gallery/IMG_1454.jpg", caption: "Program Sessions" },
    { src: "/images/gallery/3F5D2DEA-0D1E-46C3-8AEE-23AFBF9B7EA5.jpg", caption: "Wellness Programs" },
    { src: "/images/gallery/5EF9C33F-97A9-4A4F-9B5A-AE3AA54DB79F.jpg", caption: "Mental Health Awareness" },
    { src: "/images/gallery/83C59ECA-81EF-459C-AE3D-EE14420890E9.jpg", caption: "Creative Expression" },
    { src: "/images/gallery/DSC03774_VSCO.jpeg", caption: "THOROpy DJ Event" },
    { src: "/images/gallery/IMG_1358.jpg", caption: "STEAM Education" },
    { src: "/images/gallery/IMG_2483.jpg", caption: "Community Impact" },
    { src: "/images/gallery/image(1).jpg", caption: "Meet at the Mountain" },
    { src: "/images/gallery/image.jpg", caption: "Outdoor Wellness" },
    { src: "/images/gallery/IMG_1369.jpg", caption: "Youth Empowerment" },
    { src: "/images/gallery/IMG_1366.jpg", caption: "Technology Learning" },
    { src: "/images/gallery/IMG_1470.jpg", caption: "Skills Training" },
    { src: "/images/gallery/IMG_1804.JPG", caption: "Mental Health Art" },
    { src: "/images/gallery/IMG_1808.JPG", caption: "Wellness Initiative" },
    { src: "/images/gallery/DSC03789_VSCO.jpeg", caption: "Program Celebration" }
  ];

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="pt-32 pb-16 px-4 bg-gradient-to-br from-[#FFE102] to-[#ffd700]">
        <div className="max-w-7xl mx-auto text-center">
          <ImageIcon className="w-16 h-16 mx-auto mb-6 text-[#17181B]" />
          <Badge className="bg-[#17181B] text-white font-bold mb-6">Photo Gallery</Badge>
          <h1 className="text-5xl md:text-6xl font-bold text-[#17181B] mb-6">See Our Impact in Action</h1>
          <p className="text-xl text-[#17181B]/80 max-w-4xl mx-auto">
            Real moments from our STEAM workshops, THOROpy sessions, Meet at the Mountain wellness hikes, and community events.
          </p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {galleryPhotos.map((photo, index) => (
              <div key={index} className="group relative aspect-square overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all">
                <img 
                  src={photo.src} 
                  alt={photo.caption} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <p className="text-white font-semibold text-sm">{photo.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <p className="text-gray-600 text-lg mb-4">Want to see more from our programs?</p>
            <p className="text-gray-600">Follow us on social media or visit us in person to experience the Calvin D. Butts Inc. difference!</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Gallery;